import createDeepEqualSelector from 'utils/reselect/typescript/createDeepEqualSelector';
import { AppState } from 'services/types';
import { HALF_THE_CALCULATION } from 'services/sprayEvents/constants';
import { selectTotalArea } from '../../../../../../selectors';

type Props = {
    needHalfCalculation: boolean;
};

const selectNeedHalfCalculation = (state: AppState, props: Props): boolean =>
    props.needHalfCalculation;

const selectTotalAreaIfPerOperator = createDeepEqualSelector(
    selectTotalArea,
    selectNeedHalfCalculation,
    (totalArea, needHalfCalculation) => {
        if (needHalfCalculation) {
            return totalArea / HALF_THE_CALCULATION;
        }
        return totalArea;
    }
);
const makeSelectTotalArea = (): typeof selectTotalAreaIfPerOperator =>
    selectTotalAreaIfPerOperator;

export { makeSelectTotalArea };
